module.exports = __webpack_public_path__ + "media/images/faq/infl3-7ce54175f7e4e9195c5ad0fcae7eef79.png";